<div class="widgets_adicionales">
	<div class="widget_add" *ngFor="let item of items">
		<span>
			<h5>{{ item.title }}</h5>
			<p>{{ item.subTitle }}</p>
		</span>
	</div>
</div>
